import cn from "classnames";
import { isLastIndexOfArray } from "helpers";
import { t } from "i18next";
import { Fragment } from "react";

import { HeaderStatisticProps } from "./HeaderStatistic.types";

import styles from "./HeaderStatistic.module.scss";

const HeaderStatistic = ({
  statistic,
  valueClassName,
  labelClassName
}: HeaderStatisticProps) => {
  return (
    <div className={styles.statistic}>
      {statistic?.map(({ label, value }, index, array) => (
        <Fragment key={index}>
          <div>
            <div className={cn(styles.statistic_value, valueClassName)}>
              {value?.toLocaleString("en-US") ?? 0}
            </div>
            <div className={cn(styles.statistic_label, labelClassName)}>
              {t(label)}
            </div>
          </div>

          {!isLastIndexOfArray(index, array) && (
            <div className={styles.statistic_separator} />
          )}
        </Fragment>
      ))}
    </div>
  );
};

export default HeaderStatistic;
